var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableurDm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.041,
    viewBox: "0 0 40 48.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_367",
    "data-name": "Groupe 367",
    transform: "translate(-61.429 -134.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_409",
    "data-name": "Groupe 409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_565",
    "data-name": "Trac\\xE9 565",
    d: "M95.429,182.736h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.436.06,14.748,0,17.6-.028,3.556-.038,3.623-.038,4.274.612.408.407,5.136,6.359,6.05,7.514,6.063,7.662,6.063,7.753,6.063,8.623v25.279A6.007,6.007,0,0,1,95.429,182.736Zm-28-44a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V152.03C95.97,149.99,89,141.2,86.937,138.692c-.461,0-1.112.008-1.853.016C82.22,138.739,76.889,138.794,67.424,138.736Z",
    fill: "#3bc14e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1358",
    "data-name": "Rectangle 1358"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1407",
    "data-name": "Rectangle 1407",
    width: 23,
    height: 16,
    transform: "translate(68.712 156.736)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_566",
    "data-name": "Trac\\xE9 566",
    d: "M91.711,172.736h-23v-16h23Zm-20-3h17v-10h-17Z",
    fill: "#3bc14e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1359",
    "data-name": "Rectangle 1359"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1408",
    "data-name": "Rectangle 1408",
    width: 16,
    height: 16,
    transform: "translate(75.712 156.736)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_567",
    "data-name": "Trac\\xE9 567",
    d: "M91.711,172.736h-16v-16h16Zm-13-3h10v-10h-10Z",
    fill: "#3bc14e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1360",
    "data-name": "Rectangle 1360"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1409",
    "data-name": "Rectangle 1409",
    width: 23,
    height: 9,
    transform: "translate(68.712 156.736)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_568",
    "data-name": "Trac\\xE9 568",
    d: "M91.711,165.736h-23v-9h23Zm-20-3h17v-3h-17Z",
    fill: "#3bc14e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableurDm);
export default __webpack_public_path__ + "static/media/tableurDM.71b870bef3b5ceeb206a4b1298350e48.svg";
export { ForwardRef as ReactComponent };